var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"options-card"},[_c('v-card-title',{staticClass:"marco white--text"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider'),_c('v-card-text',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }